import styled from "styled-components";

export const ChartTitle = styled.div`
    height: 100%;
`;

export const TitleText = styled.p`
    font-size: 22px;
    line-height: 0%;
    margin-top: 8px;
`;

export const TitleAmount = styled.p`
    font-size: 28px;
    line-height: 10%;
    font-weight: bold;
`;